module.exports = "/virtual-football-league/img/amblems/right/logos/Huddersfield.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Huddersfield.png
// module id = 2202
// module chunks = 4